<div class="my-review-container" [ngClass]="{expanded: expanded}">
  <div class="rating-container">
    <div class="rating-row">
      <div class="rating-score">{{ratingScore}}</div>
      <div class="rating-text" [style.background]="ratingColor">{{ratingText}}</div>
    </div>
    @if (rating) {
      <div class="rating-star">
        <div class="rating-bar">
          @for (s of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]; track s) {
            <i class="star icon"
            [ngClass]="{'outline': s > rating, 'half': s > rating && s - rating < 1}"></i>
          }
        </div>
      </div>
    }
  </div>
  <div class="review-comment-container">
    @if (!!comment) {
      <div class="review-text" #reviewText>
        {{comment}}
        <div class="paragraph-light"></div>
      </div>
    }
    @if (!comment) {
      <div class="no-review-hint" [ngClass]="{'no-button': !!comment || !!rating}">
        <div class="hint-text">暂时还没有评论</div>
        <button type="button" class="ui basic tiny button" [ngClass]="{inverted: isDarkTheme}" (click)="onClickEditReview()">
          <i class="edit icon"></i> 立即评价
        </button>
      </div>
    }
  </div>
</div>
<div class="edit-button-group">
  @if (!!rating || !!comment) {
    <a class="edit-button anchor-button" (click)="onClickEditReview()">
      <i class="edit icon"></i> 编辑评价
    </a>
  }
  @if (!expanded && needTrimText) {
    <a class="expand-button anchor-button" (click)="toggleComment(true)">
      <i class="angle double down icon"></i> 展开评论
    </a>
  }
  @if (expanded && needTrimText) {
    <a class="contract-button anchor-button" (click)="toggleComment(false)">
      <i class="angle double up icon"></i> 收起评论
    </a>
  }
</div>
